export type HomeProductCardSize = 'regular' | 'large';
